import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormsEnum } from '../../../../models/enums/forms.enum';
import { JsonContentEnum } from '../../../../models/enums/json-content.enum';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { FormADMessage } from '../../../shared/models/component-messages/formAD/formAD';
import { LogService } from '../../../shared/services/log.service';
import { TypeAnn } from '../../common/models/type.ann';
import { RadioCheckBoxEnum } from '../../common/radio.checkbox.enums';
import { FormulaireServiceService } from '../../services/formulaire-service.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { TypeFacturation } from '../../common/models/type.facturation';
import { CanNavigateInStepperService } from '../../../shared/services/can-navigate-in-stepper.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../../../shared/services/http.service';
import { AutoCompleteService } from '../../../shared/services/auto-complete.service';
import { PreferencesService } from '../../../avisDePub/preferences-avis-de-pub/services/preferences.service';
import { map, takeUntil } from 'rxjs/operators';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../avisDePub/creer/services/stepper.builder.service';
import { ExchangeFile } from '../models/exchange-file';
import { FileDescriptor } from '../models/file-descriptor';

@Component({
  selector: 'app-redactionavis',
  templateUrl: './redactionavis.component.html',
  styleUrls: ['./redactionavis.component.scss']
})
export class RedactionavisComponent implements OnInit, OnDestroy, OnChanges {

  constructor(private formulaireServiceService: FormulaireServiceService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private translate: TranslateService,
    private http: HttpService,
    private preferenceService: PreferencesService, private autoCompleteService: AutoCompleteService,
    private avisDataTransferService: AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService, private spinner: SpinnerVisibilityService
  ) { }

  private LOG: LogService = new LogService(RedactionavisComponent);

  @Input() uid = '';
  @Input() disabled: boolean;
  @Input() linkForRouter: string;
  @Input() form: FormGroup;
  @Input() indexPage;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  @Input() fadIndex: number;
  public createForm = false;
  public isFormValid = true;
  public current_uid = 'formAD';
  public ann = new TypeAnn();

  public readonly ouiValue = RadioCheckBoxEnum.ouiValue;
  public readonly nonValue = RadioCheckBoxEnum.nonValue;

  public radioButtonValue: string;
  public radioButtonCtrlName: string;

  chargePrefLogo = false;
  private unsubscribe$ = new Subject<void>();

  public textAreaValue: string;

  private _file: File | FileDescriptor = null;

  public get file(): File | FileDescriptor {
    return this._file;
  }

  public formADMessage = new FormADMessage();

  public firstTextArea = '<div style="text-align: center; font-weight: bold; padding-bottom: 2.5em;"><font size=\'6\'>[Titre de l\'avis]</font></div><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section I - Identification de l\'organisme qui passe le march&#233;</font></div><ol><font size=\'4\'><li>Type d\'organisme : </li><li>Nom de l\'organisme : </li><li>Adresse : </li><li>Nom/Pr&#233nom : </li><li>Email/Fax : </li><li>Adresse du pouvoir adjudicateur (URL) : </li><li>Adresse du profil d\'acheteur (URL) : </li></ol></font></ol><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section II - Objet du march&#233;</font></div><ol><font size=\'4\'><li>Intitul&#233 du march&#233 : </li><li>Type de march&#233 : </li><li>Description succincte du march&#233 (lieu d\'ex&#233cution du march&#233, description des lots, informations rectificatives, motif de l\'annulation) : </li><li>Classification CPV : </li><li>Attribution des lots : </li><li>Dur&#233e du march&#233 et/ou d&#233lais d\'ex&#233cution : </li></ol></font></ol><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section III - Proc&#233;dure de passation du march&#233</font></div><ol><font size=\'4\'><li>Type de proc&#233dure : </li></ol></font></ol><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section IV - Justifications à produire par le candidat</font></div><ol><font size=\'4\'><li>Justifications à produire quant aux qualit&#233s et capacit&#233s du candidat : </li></ol></font></ol><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section V - Attribution du march&#233</font></div><ol><font size=\'4\'><li>Critères d\'attribution : </li><li>R&#233sultats du march&#233 : </li></ol></font></ol><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section VI - Date de remise des offres</font></div><ol><font size=\'4\'><li>Date limite de r&#233ception des offres et/ou des candidatures : </li></ol></font></ol><div style="font-weight: bold; padding: 0.5em 0;"><font size=\'5\'>Section VII - Renseignements compl&#233;mentaires</font></div><ol><font size=\'4\'><li>Informations compl&#233mentaires : </li><li>Date d\'envoi du pr&#233sent avis : </li></font></ol>';

  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Entrez le texte ici...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      ['insertImage',
        'insertVideo',]
    ]
  };

  ngOnInit(): void {
    // toujours initialiser le formulaire avec les deux controles names :
    this.form.addControl(this.getUid() + '_SepAtt_TextArea', new FormControl());
    this.form.addControl(this.getUid() + '_SepAtt_logo', new FormControl());
    this.form.addControl(this.getUid() + '_SepAtt_afficherLogo', new FormControl());
    this.initForm();
    this.radioButtonCtrlName = this.getUid() + '_SepAtt_afficherLogo';
    if (this.form.controls[this.getUid() + '_SepAtt_TextArea'].value !== undefined) {
      this.textAreaValue = this.form.controls[this.getUid() + '_SepAtt_TextArea'].value;
    }
  }

  ngAfterViewInit() {
    this.form.controls[this.getUid() + '_SepAtt_TextArea'].valueChanges.subscribe(data => {
      this.formulaireServiceService.formulaireAdapte = true;
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.radioButtonValue?.currentValue === this.ouiValue) {
      this.getPreferenceLogo();
        }
  }

  private initForm() {
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string' && !this.createForm) {
        // dans le cas ou data !=null donc
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage > 0.4) {
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        }
        this.formulaireServiceService.formulaireAdapte = data.jsonPdf?.formulaireAdapte;
        this.getFormAdp();
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.spinner.hide()
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.FORM_AD, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.createForm = true;
          this.ann = formData.jsonSaisieFormulaire.ann;
          this.formulaireServiceService.formulaireAdapte = false;
          this.getFormAdp();
          const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
          this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation = formData.refConsultation;
          if (formData.jsonSaisieFormulaire.ann.formAD.facturation.libelle.siret)
            this.avisDataTransferService.siret = formData.jsonSaisieFormulaire.ann.formAD.facturation.libelle.siret;
            this.spinner.hide()
        });
      }
    });
  }

  isFAD() {
    return this.canNavigateInStepperService.currentFormulaire == 'FORM_AD' || this.stepperBuilderService?.formulaire?.toString() === 'FORM_AD';
  }

  getFormAdp() {
    if (!this.ann.formAD) { return; }
    if (this.ann.formAD.textArea != null && this.ann.formAD.textArea != undefined && this.ann.formAD.textArea != '') {
      const temptxt = decodeURI(
        (this.ann.formAD.textArea != 'undefined' ?
          (this.ann.formAD.textArea != 'dW5kZWZpbmVk' ?
            (btoa(this.ann.formAD.textArea) == btoa(this.firstTextArea) ? this.ann.formAD.textArea : decodeURI(atob(this.ann.formAD.textArea)))
            : this.firstTextArea)
          : this.firstTextArea));
      this.ann.formAD.textArea = temptxt;
      this.form.controls[this.getUid() + '_SepAtt_TextArea'].setValue(this.ann.formAD.textArea);
    } else {
      this.form.controls[this.getUid() + '_SepAtt_TextArea'].setValue(this.firstTextArea);
    }

    const logo: ExchangeFile = ExchangeFile.fromJson(this.ann.formAD.logo);

    if (logo !== null) {
      this.form.controls[this.getUid() + '_SepAtt_afficherLogo'].setValue(this.ouiValue);
      this.form.controls[this.getUid() + '_SepAtt_logo'].setValue(logo);
      this.radioButtonValue = this.ouiValue;
      this._file = logo.toDescriptor();
    }
    else {
      this.radioButtonValue = this.nonValue;
    }
    if (this.isFAD()) {
      // TODO later
      // this.setFacturation(facturation);
    }
  }

  setFacturation(facturation: TypeFacturation) {
    this.form.controls._SepSep_idAnnonceur_SepAtt_codepostal.setValue(facturation.libelle.cp);
    this.form.controls._SepSep_idAnnonceur_SepAtt_compladresseboitepostale.setValue(facturation.libelle.adr4);
    this.form.controls._SepSep_idAnnonceur_SepAtt_denomination.setValue(facturation.libelle.denomination);
    this.form.controls._SepSep_idAnnonceur_SepAtt_engagementjuridique.setValue(facturation.numBonCommande);
    this.form.controls._SepSep_idAnnonceur_SepAtt_immeublebatiment.setValue(facturation.libelle.adr2);
    this.form.controls._SepSep_idAnnonceur_SepAtt_numerolibellevoie.setValue(facturation.libelle.adr3);
    this.form.controls._SepSep_idAnnonceur_SepAtt_pays.setValue(facturation.libelle.pays);
    this.form.controls._SepSep_idAnnonceur_SepAtt_servicedestinataire.setValue(facturation.libelle.adr1);
    this.form.controls._SepSep_idAnnonceur_SepAtt_serviceexec.setValue(facturation.noServiceExecutant);
    this.form.controls._SepSep_idAnnonceur_SepAtt_siret.setValue(facturation.libelle.siret);
    this.form.controls._SepSep_idAnnonceur_SepAtt_tvaIntracommunautaire.setValue(facturation.libelle.tvaIntracommunautaire);
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isOui() {
    if (this.form.controls[this.getUid() + '_SepAtt_afficherLogo'].value === this.ouiValue) {
      if (!this.chargePrefLogo) {
        this.getPreferenceLogo();
      }
    } else {
      this.chargePrefLogo = false;
    }
    return this.form.controls[this.getUid() + '_SepAtt_afficherLogo'].value === this.ouiValue;
  }


  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete the logo file
   */
  deleteFile() {
    this._file = null;
    (<HTMLInputElement>document.getElementById('fileDropRef')).value = '';
    this.form.controls[this.getUid() + '_SepAtt_logo'].reset();
    this.ann.formAD.logo = null;
  }


  private static acceptedTypes: string[] = ["image/png", "image/jpeg"];

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: File[]) {
    if (files == null) { return; }

    const file: File = files[0];

    if (
      RedactionavisComponent.acceptedTypes.includes(file.type) &&
      file.size <= 400000
    ) {
      this._file = file;
      const logo = await ExchangeFile.fromFile(file);
      this.form.controls[this.getUid() + '_SepAtt_logo'].setValue(logo);
      this.ann.formAD.logo = logo;
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  getPreferenceLogo(): void {
    this.chargePrefLogo = true;
    this.preferenceService.getLogoFull().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          const reader = new FileReader();
          let image: Blob = new Blob();
          if (data.length > 0) {
            image = this.b64toBlob([data[0].logo], data[0].content.values.find(item => item.code === 'type').value);
          }
          reader.addEventListener('load', () => {
            const imageToShow = reader.result;
            if (imageToShow !== 'data:') {
              if (data.length > 0) {
                const files: any[] = [];
                files.push(this.blobToFile(image, data[0].titre));
                this.prepareFilesList(files);
              }
            }
          }, false);

          if (image) {
            reader.readAsDataURL(image);
          }
        })
      });
  }

  private b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  private blobToFile = (theBlob: Blob, fileName: string): File => new File([theBlob], fileName, { type: theBlob.type })

  generateAD() {
    if (this.isFAD()) {
      this.form.controls[this.getUid() + '_SepAtt_TextArea'].setValue(this.firstTextArea);
    } else {
      const jsonCSV = this.avisDataTransferService.jsonCSV;
      this.FADfromJSON(jsonCSV).subscribe(text => { this.form.controls[this.getUid() + '_SepAtt_TextArea'].setValue(text); this.formulaireServiceService.formulaireAdapte = false; });
    }
  }

  processJSON(json) {
    let s = '';
    json.formulaire.forEach(data => {
      const label = data.label ? this.translate.instant(data.label) : '';
      switch (data.type) {
        case 'legend': s += '<br/><h3>' + label + '</h3>'; break;
        case 'text': s += label + ' : ' + data.value + '<br/>'; break;
        case 'date': s += label + ' : ' + data.value + '<br/>'; break;
        case 'datetime': s += label + ' : ' + data.value + '<br/>'; break;
        case 'radio': s += label + ' : ' + this.translate.instant(data.value) + '<br/>'; break;
        case 'checkbox': s += (data.value !== null) ? ' - ' + label + '<br/>' : ''; break;
      }
    });
    return s;
  }

  FADfromJSON(jsonCSV) {

    return this.http.get('assets/data/adaptForms/' + this.formName + '.json', null, { basePath: '' }).pipe(map((data: any) => {
      data = data.template.replace(/(?:\r\n|\r|\n)/g, '\r\n');
      const lines = data.split('\r\n');
      let savedLines: Array<string> = new Array(); // on boucle dessus si rempli, sinon on boucle sur lines
      let savingLines: Array<Array<string>> = new Array(); // on sauvegarde une entité de bloc for par lot
      let emptyFor = 0; // dans le cas d'une boucle de 0 itérations, savingLines a le même comportement qu'à l'extérieur d'une boucle
      let forLoop = 0; // indique quel niveau de for on est, 0 = pas dans une boucle
      let forCount = 0; // indique l'imbrication des for : on ne fait qu du copier/coller tant qu'on n'a pas trminé le for le plus haut
      let result = '';
      let iff = 0;
      let listing = 0;
      lines.forEach(line => {


        // on vérifie la valeur de forLoop
        // si > 0, on modifie INDEX{{forLoop}} et on ajoute à chaque case de savingLines
        // si EndFor, on fusionne savingLines et on place dans savedLines
        // si forLoop=0, ajout de line dans savedLines (conditionné?) puis traitement savedLines
        if (savingLines.length == 0 && emptyFor == 0) {
          savedLines.push(line);
        } else {
          if (line.includes('[for')) {
            forCount++;
          } else if (line.includes('[endfor]')) {
            forCount--;
          }

          if (line.includes('[endfor]') && forCount < 0) {
            forCount = 0;
            savedLines.push(line);
          } else {
            savingLines.forEach((saving, i) => {
              saving.push(line.split('INDEX' + forLoop).join((i + 1).toString()));
            });
          }
        }

        while (savedLines.length > 0) {
          let balise = false;
          let liTag = '';
          let savedLine = savedLines.shift();
          if (savedLine.includes('[unlisted]')) {
            balise = true;
            savedLine = savedLine.replace('[unlisted]', '');
          } else if (savedLine.includes('[li')) {
            liTag = savedLine.match(/(?<=\[li)(.*?)(?=\])/g)[0];
            savedLine = savedLine.replace(/\[li(.*)\]/, '');
          }
          if (savingLines.length > 0 || emptyFor > 0) {
            // si on est en train de sauvegarder, il faut mettre dans savingLines et pas dans savedLines ou result
            if (savedLine.includes('[endfor]')) {
              if (forCount) {
                forCount--;
              } else {
                const concatLines = Array<string>().concat(...savingLines);
                concatLines.push('[loop--]'); // la boucle se terminait ici, tout ce qui est avant est en INDEX(i+1)
                savedLines = concatLines.concat(savedLines);
                savingLines = new Array();
                if (emptyFor == forLoop) {
                  emptyFor = 0;
                }
              }
            } else {
              if (savedLine.includes('[for')) {
                forCount++;
              }
              savingLines.forEach((saving, i) => {
                saving.push(savedLine.replace('INDEX' + forLoop, (i + 1).toString()));
              });
            }
          } else if (savedLine.includes('[endif]')) {
            // fin de if
            iff = iff > 0 ? iff - 1 : iff;
          } else if (iff) {
            // si nous sommes encore dans une condition non respectée
            if (savedLine.includes('[if')) {
              iff++;
            }
          } else if (savedLine.includes('[if')) {
            // vérification de condition
            const f = savedLine.match(/(?<=\[if:\")(.*?)(?=\"\])/g)[0];
            const conditionValue = this.getValues(f, jsonCSV, '\'', true);
            if (conditionValue !== null && this.evaluateExpression(conditionValue)) {
              iff++;
            }
          } else if (savedLine.includes('[for')) {
            // boucle for
            const f = savedLine.match(/(?<=\[for:\")(.*?)(?=\"\])/g)[0];
            let arrays: string[] = [];
            let loop = 0;
            if (f.includes('{{')) {
              const regex = f.replace('{{', '').replace('}}', '').trim().split('INDEX' + (forLoop + 1));
              arrays = Object.entries(jsonCSV).filter((entry) => new RegExp(regex[0] + '\\d' + regex[1]).test(entry[0])).map(entry => entry[0].substring(0, entry[0].indexOf('_', regex[0].length)));
            } else if (f.includes('[')) {
              arrays = f.replace('[', '').replace(']', '').split(',');
            }
            loop = arrays.filter((el, i, a) => i === a.indexOf(el)).length;
            if (loop == 0 && emptyFor == 0) {
              emptyFor = forLoop + 1;
            }
            for (let i = 0; i < loop; i++) {
              savingLines.push(new Array());
            }
            forLoop++;
          } else if (savedLine.includes('[loop--]')) {
            if (emptyFor == forLoop) {
              emptyFor = 0;
            }
            forLoop--;
          } else if (savedLine.includes('[ol')) {
            result += '<' + savedLine.replace('[', '').replace(']', '').trim() + '>\r\n';
            listing++;
          } else if (savedLine.includes('[ul')) {
            result += '<' + savedLine.replace('[', '').replace(']', '').trim() + '>\r\n';
            listing++;
          } else if (savedLine.includes('[endOl]')) {
            result += '</ol>\r\n';
            listing--;
          } else if (savedLine.includes('[endUl]')) {
            result += '</ul>\r\n';
            listing--;
          } else if (savedLine.includes('{{')) {

            // valeur(s) à afficher
            savedLine = this.getValues(savedLine, jsonCSV);
            if (savedLine) {
              // si au moins une valeur est présente
              result += ((listing > 0 && !balise) ? '<li' + liTag + '>' : '') + '<font size="4">' + savedLine + '</font>' + ((listing > 0 && !balise) ? '</li>' : '<br/>') + '\r\n';
            }
          } else if (savedLine) {
            // texte simple
            result += ((listing > 0 && !balise) ? '<li' + liTag + '>' : '') + '<font size="5"><b>' + savedLine + '</b></font>' + ((listing > 0 && !balise) ? '</li>' : '<br/>') + '\r\n';
          } else {
            result += '<br/>\r\n';
          }
        }
      });
      return result;
    }));
  }

  getValues(line: string, jsonCSV, replacer = '', flag = false) {
    const values = line.match(/(?<={{)(.*?)(?=}})/g);
    values.forEach(value => {
      const pipes = value.split('|');
      let cvalue: string = pipes[0].trim().includes('_') ? (jsonCSV[pipes[0].trim()] != null ? jsonCSV[pipes[0].trim()] : null) : pipes[0];
      pipes.shift();
      cvalue = this.applyPipes(cvalue, pipes);
      line = line.replace('{{' + value + '}}', replacer + (cvalue ? cvalue : '') + replacer);
      if (cvalue !== null && cvalue !== undefined) {
        flag = true;
      }
    });
    return flag ? line : null;
  }

  applyPipes(value: string, pipes: string[]) {
    let untypedValue;
    pipes.forEach(pipe => {
      pipe = pipe.trim();
      switch (true) {
        case pipe.includes('isNot'): value = value ? null : ''; break;
        case pipe.includes('is'): value = value ? '' : null; break;
        case pipe.includes('boolean'): value = value == 'true' ? '' : null; break;
        case pipe.includes('toBoolean'): untypedValue = (value == 'true' || value === ''); break;
        case pipe.includes('orElse:') && (value === null || value === undefined): value = pipe.replace('orElse:', ''); break;
        default:
          if (value !== null && value !== undefined && value !== '') {
            switch (true) {
              case pipe.includes('translate'): value = this.translate.instant(value); break;
              case pipe.includes('datetime'): value = new Date(value).toLocaleString('fr-FR'); break;
              case pipe.includes('date'): value = value === 'newDate' ? new Date().toLocaleDateString('fr-FR') : new Date(value).toLocaleDateString('fr-FR'); break;
              case pipe.includes('time'): value = new Date(value).toLocaleTimeString('fr-FR'); break;
              case pipe.includes('upperCase'): value = value.toLocaleUpperCase('fr-FR'); break;
              case pipe.includes('lowerCase'): value = value.toLocaleLowerCase('fr-FR'); break;
              case pipe.includes('capitalCase'): value = value[0].toLocaleUpperCase('fr-FR') + value.substring(1).toLocaleLowerCase('fr-FR'); break;
              case pipe.includes('trim'): value = value.trim();
              case pipe.includes('currency'): value = value + '€'; break;
              case pipe.includes('percent'): value = value + '%'; break;
              case pipe.includes('toNumber'): untypedValue = Number(value); break;
              case pipe.includes('toDate'): untypedValue = new Date(value); break;
              case pipe.includes('toArray'): untypedValue = value.replace('[', '').replace(']', '').split(','); break;
              // marche pas pour les CPV sur MAPA_AN section II.5
              case pipe.includes('autocomplete'): value = this.autoCompleteService.getOptions(pipe.split('_')[1]).find(ac => value == ac.code)?.libelle; break;
              case pipe.includes('get'): value = value.replace('[', '').replace(']', '').split(',')[pipe.match(/(?<=get\()(.*)(?=\))/)[0]]; break;
              case pipe.includes('exec'): untypedValue = Function(`"use strict";return (${pipe.match(/(?<=exec\()(.*)(?=\))/)[0].replace('$value', value)})`)(); break;
              default: this.LOG.error('Pipe non reconnu : ', pipe, value);
            }
          }
      }
      if (untypedValue && typeof untypedValue === 'string') {
        value = untypedValue;
        untypedValue = undefined;
      }
    });
    return untypedValue == undefined ? value : untypedValue;
  }

  evaluateExpression(expression: string): boolean {
    const trimmedExpression = expression.split(' ').join('');
    if (trimmedExpression.includes('&&') || trimmedExpression.includes('||')) {
      const parts = trimmedExpression.split(/&&|\|\|/);
      const firstPartResult = parts[0] === "'true'";
      if (trimmedExpression.includes('&&')) {
        return firstPartResult && (this.evalExpressionWithOneOperator(parts[1]));
      }
      else if (trimmedExpression.includes('||')) {
        return firstPartResult || (this.evalExpressionWithOneOperator(parts[1]));
      }
    } else {
      return trimmedExpression.toLowerCase() === "'true'" ? true : false;
    }
    return false;
  }

  evalExpressionWithOneOperator(expression) {
    const [left, operator, right] = expression.match(/([^=!]+)([=!]+)(.+)/)!.slice(1);
    let result: boolean;
    if (operator === '===') {
      result = left.split('.')[0].toLowerCase() === right;
    } else if (operator === '!==') {
      result = left.split('.')[0].toLowerCase() !== right;
    } else {
      result = false;
    }
    return result;
  }
}
